<!--
--
-- Display Delete Conformation Dialog
--
-->

<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('attributes.deleteCompanyHeadline')}}</v-card-title>
        <v-card-text>{{dialogText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" flat @click="hideDialog()">{{$t("attributes.cancel")}}</v-btn>
          <v-btn color="red darken-1" flat @click="deleteCompany()">{{$t("attributes.deleteAction")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
    import WebService from "@/services/WebService"
    import {securityService} from '@/services/SecurityService'

    export default {
        name: 'my-company-delete-dialog',

        props: ['companyId'],

        data: () => ({
            dialog: true,
            dialogText: null
        }),

        methods: {
            deleteCompany() {
                const self = this
                new WebService(this).deleteCompany(this.companyId).then(replay => {
                  console.log('deleteCompany',replay)
                  if (replay.status >= 200 && replay.status <= 204 ){
                    self.hideDialog()
                    if (this.hasNoOtherCompany(this.companyId)){
                        securityService.signOut()
                    } else {
                      // reload companies
                       this.reloadCompanies()
                    }
                  } else {
                    self.dialogText = this.$t('errors.genericError');
                  }
                }, error => {
                    console.log('deleteCompany',error)
                    self.dialogText = this.$t('errors.genericError');
                })
            },

            hasNoOtherCompany(){
                var user = this.$store.state.user
                // admin can support any company
                if (user.role=='admin'){
                    return false
                }

                for (var company in this.$store.state.companies) {
                  if (company.id != this.companyId){
                    return true
                  }
                }
                return false
            },

            reloadCompanies() {
                  const service = new WebService(this)
                  service.getCompanies().then(response => {
                  if (response.status == 200) {
                      var companies = response.data
                      this.$store.dispatch("setCompanies", companies)
                      console.log("companies:", companies)
                      // if we have only one company we use it as selected company
                      if (companies.length >= 1) {
                          this.$router.push('/company/'+companies[0].id)
                      } else {
                          this.$router.push('/about')
                      }
                  } 
            })},

            hideDialog() {
                  this.$emit('hide-company-confirmation-dialog');
            },

        },

        mounted() {
          this.dialogText = this.$t('attributes.deleteCompanyText')
        }
    }

</script>


